<template lang="pug">
  v-row
    v-col(cols="12" sm="4" v-for="item in value", :key="'item'+item.value")
      FreespinsGameSimpleCard(:item="item" @close="removeItem(item.value)")
</template>

<script>

  import FreespinsGameSimpleCard from '@/components/cards/FreespinsGameSimpleCard';

  export default {
    name: "FreespinsGameSimpleCardGroup",
    components: {
      FreespinsGameSimpleCard,
    },
    model: {
      prop: 'value',
      event: 'input'
    },
    props: {
      value: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    methods:{
      removeItem(id){
        this.value = this.value.filter((game)=>{
          return game.value != id;
        });
        this.$emit('input', this.value);
      },
    },
  }
</script>

<style lang="sass">
</style>